import {WidgetProps} from '@wix/cashier-express-checkout-widget/dist/src/types/WidgetProps'
import {FeeType, TaxType} from '@wix/events-types'
import {getBuyerTotal, getOrderGiftCardsTotalAmount, roundPrice} from '@wix/wix-events-commons-statics'

const ZERO = '0.00'
const itemCategory = 'physical' as const

export const getDataFromInvoice = (
  invoice: wix.events.ticketing.Invoice,
  giftCardPaymentDetails?: wix.events.ticketing.GiftCardPaymentDetails[],
): Pick<WidgetProps, 'paymentBreakdown' | 'paymentAmount' | 'orderItems' | 'currency'> => {
  const orderItems = [
    ...invoice.items.map(item => ({
      id: item.id,
      name: item.name,
      price: item.price.amount,
      category: itemCategory,
      quantity: item.quantity,
    })),
    {
      id: 'WixEventFees',
      name: 'WixEventFees',
      price: invoice.fees
        .filter(fee => [FeeType.FEE_ADDED, FeeType.FEE_ADDED_AT_CHECKOUT].includes(fee.type))
        .reduce((acc, fee) => acc + Number(fee.amount.amount), 0)
        .toFixed(2)
        .toString(),
      category: itemCategory,
      quantity: 1,
    },
  ].filter(item => Number(item.price))

  const taxIncluded = invoice.tax?.type === TaxType.INCLUDED
  const discountAmount =
    Number(invoice.discount?.amount.amount ?? ZERO) + getOrderGiftCardsTotalAmount(giftCardPaymentDetails)

  return {
    paymentAmount: getBuyerTotal(invoice.grandTotal, giftCardPaymentDetails).amount,
    currency: invoice.grandTotal.currency,
    orderItems,
    paymentBreakdown: {
      itemsTotal: orderItems
        .reduce((acc, item) => acc + Number(item.price) * item.quantity, 0)
        .toFixed(2)
        .toString(),
      shipping: ZERO,
      tax: taxIncluded ? ZERO : (invoice.tax?.amount?.amount ?? ZERO),
      discount: roundPrice(discountAmount, invoice.grandTotal.currency),
    },
  }
}
